import { useTranslation } from "react-i18next";

import { HomePageSection } from "../HomePageSection";
import { PsButtonTuner } from "stencilSetup";
import { Card } from "components";

interface TotalCompensationStatementProps {
  apiHost?: string,
  totalCompensationData?: {
    subject: string;
    tentant: string;
    responseOn_IS08601: string;
    displayMessage_enUS: string;
    actionSequence?: { viewOnline_samlRelayState: string }[];
  }
}

export const TotalCompensationStatement = ({
  apiHost,
  totalCompensationData,
}: TotalCompensationStatementProps) => {
  const { t } = useTranslation("pages.home");

  const displayMessage = totalCompensationData?.displayMessage_enUS;

  const handleClick = () => {
    const actionSequence = totalCompensationData?.actionSequence ? totalCompensationData?.actionSequence[0] : null;

    if (!actionSequence) {
      return;
    }

    const samlUrl = actionSequence.viewOnline_samlRelayState;
    const endpointUrl = `/sso/subscriber_identity_provider/send_to_service_provider?provider=brain_power&relay_state_override=${samlUrl}`;
    const statementUrl = `${apiHost}${endpointUrl}`;

    window.open(statementUrl, '_blank');
  };

  return (
    <HomePageSection
      title={t("totalCompensation.title")} additionalClasses="order-md-6 order-6">
       <Card additionalClasses="w-100" showBorder>
        <p className="mb-3">{t('totalCompensation.description')} {displayMessage}</p>
        <PsButtonTuner
          buttonId="view-statement-btn"
          data-testid="view-statement-btn"
          type="button"
          level="secondary"
          label={t('totalCompensation.viewStatement')}
          onClick={handleClick}
        />
       </Card>
    </HomePageSection>
  );
};
